import { render, staticRenderFns } from "./messageRemind.vue?vue&type=template&id=4932c658&scoped=true&"
import script from "./messageRemind.vue?vue&type=script&lang=js&"
export * from "./messageRemind.vue?vue&type=script&lang=js&"
import style0 from "./messageRemind.vue?vue&type=style&index=0&id=4932c658&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4932c658",
  null
  
)

export default component.exports